export default "__VITE_ASSET__8cf43118__"